<template>
  <section class="reviews-qa-section">
    <div class="container">
      <!-- Testimonials First -->
      <section class="testimonials-section" v-if="testimonials && testimonials.length">
        <div class="testimonials-grid">
          <div class="testimonial-card" v-for="testimonial in testimonials" :key="testimonial.id">
            <span class="quote-mark">"</span>
            <p class="testimonial-text">{{ testimonial.text }}</p>
            <div class="testimonial-author">
              <img :src="testimonial.avatar || '/avatars/pet-default.jpg'" alt="" />
              <div class="author-info">
                <strong>{{ testimonial.petName }}</strong>
                <span>{{ testimonial.petInfo }}</span>
                <span>{{ testimonial.location }}</span>
              </div>
            </div>
            <div class="testimonial-stars">
              <span v-for="n in 5" :key="n" class="star filled">★</span>
            </div>
          </div>
        </div>
      </section>

      <div class="content-grid">
        <div class="qa-column">
          <h2>Questions & Answers</h2>
          <div class="qa-list">
            <div class="qa-item" v-for="(qa, index) in questions" :key="index">
              <div class="question">
                <span class="q-icon">?</span>
                <strong>{{ qa.question }}</strong>
              </div>
              <p class="answer" v-if="qa.answer">{{ qa.answer }}</p>
            </div>
          </div>
        </div>

        <div class="reviews-column">
          <div class="reviews-header">
            <h2>Customer Reviews</h2>
            <div class="overall-rating">
              <div class="stars-large">
                <span v-for="n in 5" :key="n" class="star filled">★</span>
              </div>
              <span class="rating-large">4.9</span>
              <span class="based-on">Based on {{ reviews.length }} Reviews</span>
            </div>
            <button class="write-review-btn">WRITE A REVIEW</button>
          </div>

          <div class="review-list">
            <div class="review-card" v-for="review in reviews" :key="review.id">
              <div class="review-header">
                <img :src="review.avatar || '/avatars/default.jpg'" alt="User" class="reviewer-avatar" />
                <div class="review-info">
                  <div class="review-stars">
                    <span v-for="n in 5" :key="n" class="star" :class="{ filled: n <= (review.rating || 5) }">★</span>
                  </div>
                  <h4>{{ review.title }}</h4>
                  <div class="review-meta">
                    <span class="reviewer-name">{{ review.username || review.petName }}</span>
                    <span class="review-date" v-if="review.date">Review on {{ review.date }}</span>
                  </div>
                </div>
              </div>
              <p class="review-text">{{ review.text }}</p>
              <div class="pet-info" v-if="review.petName || review.petType">
                <strong v-if="review.petName">{{ review.petName }}</strong>
                <template v-if="review.petName && review.petType"> | </template>
                <span v-if="review.petType">{{ review.petType }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ReviewsQASection',
  props: {
    reviews: {
      type: Array,
      required: true
    },
    questions: {
      type: Array,
      required: true
    },
    testimonials: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
.reviews-qa-section {
  background: #fffef9;
  padding: 60px 0;
}

.content-grid {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 60px;
}

.reviews-header {
  margin-bottom: 30px;
}

.reviews-header h2 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
}

.overall-rating {
  background: #f9f9f9;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  margin-bottom: 20px;
}

.stars-large {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-bottom: 10px;
}

.stars-large .star {
  font-size: 24px;
  color: #e37267;
}

.rating-large {
  font-size: 32px;
  font-weight: 700;
  margin-right: 10px;
}

.based-on {
  font-size: 11px;
  color: #000;
}

.write-review-btn {
  width: 100%;
  padding: 12px;
  background: #e37267;
  color: white;
  border: none;
  border-radius: 5px;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.3s;
}

.write-review-btn:hover {
  background: #d27b6f;
}

.review-list {
  margin-top: 30px;
}

.review-card {
  border-bottom: 1px solid #f0f0f0;
  padding: 20px 0;
}

.review-header {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.reviewer-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background: #f0f0f0;
}

.review-info { flex: 1; }

.review-stars {
  display: flex;
  gap: 2px;
  margin-bottom: 5px;
}

.review-stars .star { color: #e0e0e0; }
.review-stars .star.filled { color: #e37267; }

.review-info h4 {
  font-size: 14px;
  font-weight: 700;
  margin: 5px 0;
}

.review-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  margin-bottom: 5px;
}

.reviewer-name { font-style: italic; color: #000; }
.review-date { color: #666; font-size: 10px; }

.review-text { font-size: 12px; line-height: 1.5; color: #000; margin-bottom: 10px; }
.pet-info { font-size: 12px; color: #d78d86; }

.qa-column h2 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
}

.qa-list { margin-bottom: 40px; }
.qa-item { margin-bottom: 20px; }

.question {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 8px;
}

.q-icon { width: 19px; height: 19px; flex-shrink: 0; }

.question strong { font-size: 14px; font-weight: 700; color: #000; }
.answer { margin-left: 29px; font-size: 12px; color: #000; line-height: 1.5; }

/* Testimonials Section */
.testimonials-section { background: #fffef9; padding: 60px 0; }
.testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 30px; }
.testimonial-card { background: white; border: 2px solid #ffe1cf; border-radius: 20px; padding: 30px; position: relative; }
.quote-mark { position: absolute; top: 10px; left: 20px; font-family: 'Eczar', serif; font-size: 80px; color: #e37267; line-height: 1; }
.testimonial-text { margin: 40px 0 20px; font-size: 12px; line-height: 1.5; color: #000; }
.testimonial-author { display: flex; align-items: center; gap: 10px; margin-bottom: 15px; }
.testimonial-author img { width: 42px; height: 42px; border-radius: 50%; object-fit: cover; background: #f0f0f0; }
.author-info { display: flex; flex-direction: column; gap: 2px; }
.author-info strong { font-size: 12px; color: #000; }
.author-info span { font-size: 10px; color: #908c8c; }
.testimonial-stars { display: flex; gap: 2px; }
.testimonial-stars .star { color: #e37267; font-size: 14px; }

@media (max-width: 992px) {
  .testimonials-grid { grid-template-columns: 1fr; }
}

@media (max-width: 992px) {
  .content-grid { grid-template-columns: 1fr; }
}
</style>

